module.exports = __webpack_public_path__ + "img/otrosIngresos64.b1829bf9.png";